export interface Quote {
  text: string;
  author: string;
  category: 'motivation' | 'tired' | 'anxious' | 'sad' | 'happy' | 'challenge' | 'life' | 'hope';
}

export const quotes: Quote[] = [
  // モチベーション・挑戦
  {
    text: '10年後にはきっと、せめて10年でいいからもどってやり直したいと思っているのだろう。今やり直せよ。未来を。10年後か、20年後か、50年後からもどってきたんだよ今。',
    author: '2ちゃんねる就職板',
    category: 'motivation'
  },
  {
    text: 'あきらめたらそこで試合終了だよ',
    author: '安西光義（スラムダンク）',
    category: 'challenge'
  },
  {
    text: '夢は逃げない、逃げるのはいつも自分だ。',
    author: '高橋歩',
    category: 'motivation'
  },
  {
    text: '人間は負けたら終わりなのではない。辞めたら終わりなのだ。',
    author: 'リチャード・ニクソン',
    category: 'challenge'
  },
  {
    text: '努力した者が全て報われるとは限らん。しかし、成功した者は皆すべからく努力しておる！！',
    author: '鴨川源二（はじめの一歩）',
    category: 'motivation'
  },
  {
    text: '負けても終わりではない。やめたら終わりだ。',
    author: 'リチャード・ニクソン',
    category: 'challenge'
  },
  {
    text: 'お前の道を進め、人には勝手なことを言わせておけ。',
    author: 'ダンテ・アリギエーリ',
    category: 'motivation'
  },
  {
    text: '人に勝つより、自分に勝て。',
    author: '嘉納治五郎',
    category: 'motivation'
  },

  // 疲れ・不安
  {
    text: '考えすぎると、人間は臆病になる。',
    author: '映画「コクーン」',
    category: 'anxious'
  },
  {
    text: '傷ついたのは、生きたからである。',
    author: '高見順',
    category: 'tired'
  },
  {
    text: '枯れない花はないが、咲かない花はある。世の中は決定的に不公平だ',
    author: '西尾維新',
    category: 'sad'
  },
  {
    text: 'お前が死んでも何も変わらない。だが、お前が生きて、変わるものもある。',
    author: '玄奘三蔵（最遊記）',
    category: 'hope'
  },

  // 希望・前向き
  {
    text: '全てが失われようとも、まだ未来が残ってる。',
    author: 'クリスチャン・ネステル・ボヴィー',
    category: 'hope'
  },
  {
    text: '希望さえあればどんな所にでもたどりつけると決心している。',
    author: 'ジョルノ・ジョバーナ（ジョジョの奇妙な冒険）',
    category: 'hope'
  },
  {
    text: '努力する人は希望を語り、怠ける人は不満を語る',
    author: '井上靖',
    category: 'hope'
  },
  {
    text: '昨日から学び、今日を生き、明日へ期待しよう',
    author: 'アルベルト・アインシュタイン',
    category: 'hope'
  },

  // 人生・時間
  {
    text: '今日という日は、残りの人生の最初の一日。',
    author: '映画「アメリカン・ビューティー」',
    category: 'life'
  },
  {
    text: '人生は一冊の書物に似ている。馬鹿者たちはそれはパラパラとめくっているが、賢い人間はそれを念入りに読む。なぜなら、彼はただ一度しかそれを読むことが出来ないのを知っているから。',
    author: 'ジャン・パウル',
    category: 'life'
  },
  {
    text: '生きるとは呼吸することではない。行動することだ。',
    author: 'ジャン＝ジャック・ルソー',
    category: 'life'
  },
  {
    text: 'チャンスは貯蓄できない。',
    author: '樋口廣太郎',
    category: 'challenge'
  },
  {
    text: '人間死に方は選べないが、生き方は自由だろ。',
    author: '空知英秋（銀魂）',
    category: 'life'
  },

  // 幸せ・勇気
  {
    text: '人間は大きな幸せを前にすると、急に臆病になる。幸せを勝ち取ることは、不幸に耐えることより勇気が要る',
    author: '桃子（下妻物語）',
    category: 'happy'
  },
  {
    text: '行動は必ずしも幸福をもたらさないかも知れないが、行動のない所に、幸福は、生まれない。',
    author: 'ベンジャミン・ディズレーリ',
    category: 'happy'
  },

  // 自己・成長
  {
    text: '他人と比較して、他人が自分より優れていたとしても、それは恥ではない。しかし、去年の自分より今年の自分が優れていないのは立派な恥だ。',
    author: 'ジョン・ラボック',
    category: 'motivation'
  },
  {
    text: 'われ思う、故にわれあり。',
    author: 'ルネ・デカルト',
    category: 'life'
  },
  {
    text: '神に誓うな 己に誓え',
    author: '藤原基央',
    category: 'motivation'
  },

  // 思いやり・人間関係
  {
    text: 'やってみせて、言って聞かせて、やらせてみて、ほめてやらねば人は動かじ。話し合い、耳を傾け、承認し、任せてやらねば、人は育たず。やっている、姿を感謝で見守って、信頼せねば、人は実らず。',
    author: '山本五十六',
    category: 'life'
  },
  {
    text: '花よりも花を咲かせる土になれ',
    author: '山下智茂監督',
    category: 'life'
  },
  {
    text: 'のび太くんを選んだ君の判断は正しかったと思うよ。あの青年は人の幸せを願い、人の不幸を悲しむことのできる人だ。それが人間にとって大事なことなんだからね。',
    author: '源義雄（ドラえもん）',
    category: 'life'
  },

  // 創造性・挑戦
  {
    text: '人が空想できる全ての出来事は起こりうる現実である',
    author: 'ウィリー・ガーソン',
    category: 'challenge'
  },
  {
    text: '卵を割らなければ、オムレツは作れない。',
    author: '映画「オール・ザ・キングスメン」',
    category: 'challenge'
  },
];

/**
 * 感情カテゴリに基づいて名言を取得
 */
export function getQuoteByCategory(category: Quote['category']): Quote | null {
  const filtered = quotes.filter((q) => q.category === category);
  if (filtered.length === 0) return null;
  return filtered[Math.floor(Math.random() * filtered.length)];
}

/**
 * ユーザーのメッセージから感情を推測して適切な名言を返す
 */
export function getQuoteForUserMessage(userText: string): Quote | null {
  const tiredWords = ['疲れた', 'しんどい', 'つらい', '大変', 'きつい', '辛い'];
  const anxiousWords = ['不安', '心配', '怖い', '緊張', 'どうしよう'];
  const sadWords = ['悲しい', '泣いた', '寂しい', 'さみしい', '切ない'];
  const happyWords = ['嬉しい', '楽しい', '良かった', '最高', '幸せ'];
  const challengeWords = ['頑張', '挑戦', 'やってみ', '始め', 'チャレンジ'];

  if (tiredWords.some((w) => userText.includes(w))) return getQuoteByCategory('tired');
  if (anxiousWords.some((w) => userText.includes(w))) return getQuoteByCategory('anxious');
  if (sadWords.some((w) => userText.includes(w))) return getQuoteByCategory('sad');
  if (happyWords.some((w) => userText.includes(w))) return getQuoteByCategory('happy');
  if (challengeWords.some((w) => userText.includes(w))) return getQuoteByCategory('challenge');

  // デフォルトは希望・人生系
  const defaultCategories: Quote['category'][] = ['hope', 'life', 'motivation'];
  const category = defaultCategories[Math.floor(Math.random() * defaultCategories.length)];
  return getQuoteByCategory(category);
}